import { Box, Dialog, Paper, Typography } from '@mui/material';
import React, { useState } from 'react';
import UnspentPointsPanel from './PointSpend';
import ResourceBar from './ResourceBar';
const CharacterOverview = ({ character, tabHeight, BASE_URL, game_id, token }) => {
    const {
        name,
        archetype,
        subtype,
        level,
        experience,
        attributes,
    } = character;
    const [open, setOpen] = useState(false);
    const avatarUrl = `${BASE_URL}/v1/image/${game_id}/avatar.png?token=${token}`;

    return (
        <Box
            sx={{
                height: `calc(100vh - ${tabHeight})`,
                boxSizing: 'border-box',
                overflowY: 'auto',
                p: 1,
            }}
        >

            {/* Points Section */}
            <UnspentPointsPanel
                skillPoints={1}
                attributePoints={1}
                resourcePoints={20}
                onAllocateSkill={() => console.log('Allocating skill')}
                onAllocateAttribute={() => console.log('Allocating attribute')}
                onAllocateResource={() => console.log('Allocating resource')}
            />



            {/* Header Section: Avatar + Info Side by Side */}
            <Paper elevation={3} sx={{ p: 2, mb: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>

                    {/* Left: Info */}
                    <Box sx={{ flex: 1 }}>
                        <Typography variant="h6" component="div" sx={{ marginBottom: 1 }}>{name}</Typography>
                        <Typography>{archetype}</Typography>
                        {subtype && <Typography>{subtype}</Typography>}
                        <Typography><strong>Level:</strong> {level}</Typography>
                        <Typography><strong>XP:</strong> {experience}</Typography>
                    </Box>

                    {/* Right: Avatar */}
                    <Box sx={{ width: '50%', display: 'flex', alignItems: 'center', gap: 2 }} onClick={() => setOpen(true)}>
                        <img
                            src={`${BASE_URL}/v1/image/${game_id}/avatar.png?token=${token}`}
                            alt="Avatar"
                            style={{ width: '100%', borderRadius: '12px', border: '1px solid #ccc' }}
                        />
                    </Box>

                    {/* Modal with larger image */}
                    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm">
                        <Box sx={{ p: 2 }} onClick={() => setOpen(false)}>
                            <img
                                src={avatarUrl}
                                alt="Enlarged Avatar"
                                style={{ width: '100%', borderRadius: '12px' }}
                            />
                        </Box>
                    </Dialog>
                </Box>
            </Paper >

            {/* Resource Bars Section */}
            < Paper elevation={3} sx={{ padding: 2, marginBottom: 2 }}>
                <Typography>
                    <strong>Health:</strong> 30/30
                </Typography>
                <ResourceBar value={30} max={30} color="#CC6E3D" />
                <Typography sx={{ marginTop: 1 }}>
                    <strong>Stamina:</strong> 40/40
                </Typography>
                <ResourceBar value={40} max={40} color="#6D9A56" />
                <Typography sx={{ marginTop: 1 }}>
                    <strong>Mind:</strong> 30/30
                </Typography>
                <ResourceBar value={30} max={30} color="#5D5C9C" />

            </Paper >

            {/* Effects Section */}
            < Paper elevation={3} sx={{ padding: 2, marginBottom: 2 }}>
                <Typography variant="h6">
                    Effects
                </Typography>
                <Typography>
                    You have no active effects.
                </Typography>
            </Paper >

            {/* Attributes Section */}
            < Paper elevation={3} sx={{ p: 2, mb: 2 }}>
                <Typography variant="h6">
                    Attributes
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box sx={{ flex: 1 }}>
                        <Typography><strong>Might:</strong> {attributes.might}</Typography>
                        <Typography><strong>Reflexes:</strong> {attributes.reflexes}</Typography>
                        <Typography><strong>Fortitude:</strong> {attributes.fortitude}</Typography>
                        <Typography><strong>Perception:</strong> {attributes.perception}</Typography>
                    </Box>
                    <Box sx={{ flex: 1 }}>
                        <Typography><strong>Cunning:</strong> {attributes.cunning}</Typography>
                        <Typography><strong>Resolve:</strong> {attributes.resolve}</Typography>
                        <Typography><strong>Guile:</strong> {attributes.guile}</Typography>
                        <Typography><strong>Presence:</strong> {attributes.presence}</Typography>
                    </Box>
                </Box>
            </Paper >


        </Box >
    );
};

export default CharacterOverview;
